import { render, staticRenderFns } from "./ConfirmFolders.vue?vue&type=template&id=4c02cf84&"
import script from "./ConfirmFolders.vue?vue&type=script&lang=ts&"
export * from "./ConfirmFolders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports